import React, { useState, useEffect } from "react";

import AssetTypeLabel from "./AssetTypeLabel.jsx"
import Listbox from "./Listbox-2.jsx";

export default function AssetItems({
	itemLookup = null,
	itemLookupFn = (j, k = {}) => Promise.resolve({ items: [] }),
	activeFilters = [],
	orderBy = "",
	resultsBehavior = undefined,
	selectList,
    selected, 
    setSelected

}) {
	const [assets, setAssets] = useState({ items: [] });
	const [currentOffset, setCurrentOffset] = useState(0);
	useEffect(() => {
		if (!!itemLookup) {
			setCurrentOffset(0);
			itemLookupFn(itemLookup, {
				assetTypes: activeFilters.join(","),
				orderBy,
			}).then((response) => {
				setAssets(response);
			});
		}
	}, [itemLookup, activeFilters, orderBy]);
	useEffect(() => {
		if (currentOffset === 0) return;
		itemLookupFn(itemLookup, {
			start: currentOffset,
			assetTypes: activeFilters.join(","),
			orderBy,
		}).then((response) => {			
			setAssets({ ...assets, items: [...assets.items, ...response.items] });
		});
	}, [currentOffset]);
	return (
		<>
			{assets?.total ?
				resultsBehavior === undefined ? (

					<div className="tw-flex tw-flex-row tw-mb-8 tw-justify-between">
						<p className="tw-font-sans tw-font-light tw-text-[14px] tw-mb-0">1 - {assets.items.length} of {assets.total} Results</p>
						<div>
							<Listbox
								label="Order By"
								selectList={selectList}
								selected={selected}
								setSelected={setSelected} />
						</div>
					</div>

				) : ('')
			: null }
			<div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-x-4 tw-gap-y-8 tw-mb-10">
				{assets?.items?.map((item) => {
					return (
						<a
							key={item.id}
							href={item.file}
							target="_BLANK"
							className="tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-rounded-lg tw-flex tw-flex-col tw-overflow-hidden tw-text-text tw-ring-secondary hover:tw-ring-1"
						>
							<div
								className={`tw-flex tw-justify-center tw-items-center tw-flex-shrink-0 tw-h-[165px] tw-bg-gray-50 tw-p-[20px]`}
							>
								{item.thumb ? (
									<img
										src={item.thumb}
										className={`tw-bg-slate-50 tw-w-auto tw-h-full tw-object-contain lg:tw-object-cover tw-drop-shadow-asset`}
									/>
								) : (
									<div
										className={`tw-bg-slate-50 tw-w-full tw-max-h-full tw-h-auto`}
									>
										no preview
									</div>
								)}
							</div>
							<div className="tw-flex tw-flex-1 tw-justify-between tw-flex-col tw-p-[20px]">
								<div className="tw-leading-none tw-mb-2">
									{item.title}
								</div>
								<AssetTypeLabel asset={item} />
							</div>
						</a>
					);
				})}
			</div>
			{assets?.total && assets.total > assets.items.length ? (
				<div className="tw-flex tw-justify-center tw-my-10">
					<button
						className=""
						onClick={(e) => {
							setCurrentOffset(currentOffset + 12);
							e.currentTarget.blur();
						}}
					>
						LOAD MORE
					</button>
				</div>
			) : null}
		</>
	);
}
